import React from "react";
import GoldValueContactSection from "./GoldValueContactSection";
import CustomerStoriesSection from "./CustomerStoriesSection";
import GoldFAQSection from "./GoldFAQSection";

export default function ReusableLandingSections({
  branch,
  locationText,
  mapLink,
}) {
  return (
    <>
      <GoldValueContactSection
        locationText={locationText}
        mapLink={mapLink}
      />

      <CustomerStoriesSection />

      <GoldFAQSection
        faqs={branch?.faqs || []}
        subtitle={
          branch?.faqSubtitle ||
          "Find quick answers to common questions about selling gold with G1 Gold."
        }
      />
    </>
  );
}